{
  "duration": {
    "description": "Value is hours of duration in HH:MM format."
  },
  "validations": {
    "between": "{attribute} must be between {min} and {max}.",
    "required": "{attribute} is a required field.",
    "integer": "{attribute} must be a integer value.",
    "numeric": "{attribute} must be a numeric value.",
    "maxLength": "{attribute} must be no more than {max} characters.",
    "unique": "{attribute} must be unique.",
    "duration_numeric": "Threshold must be in format \"HH:MM\"",
    "duration_between": "Threshold must be in valid range"
  }
}
